import React, { memo } from 'react';

import EmojiPicker from 'emoji-picker-react';

const Picker = ({ onEmojiClick, ...rest }) => (
	<EmojiPicker {...rest} onEmojiClick={onEmojiClick} autoFocusSearch={false} />
);

export default memo(Picker);
